/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Filter from './filter'
import Collection from './collection'
import Response from './response'
import URI from 'urijs'

// private
const filter = new Filter({
  order: 'submitted_at',
  direction: 'DESC'
})

const responseHistoryUrl = function (participant) {
  /*
   * use a closure trick to pass
   * the participant to an anonymous
   * function that can be called later
   * without the participant object
   */

  // support both a participant instance or an id
  const id = participant.id || participant

  return () => URI('/api/participants').segment(id.toString()).segment('responses').toString()
}

export default class Responses extends Collection {
  get model () { return Response }

  initialize (options) {
    if (options == null) { options = {} }
    if (options.participant != null) {
      this.url = responseHistoryUrl(options.participant)
    }
  }

  // this is overridden by initialize
  url () {
    return '/api/participants/-1/responses'
  }

  params (obj) {
    if (obj != null) {
      return filter.set(obj)
    } else {
      return filter.attributes
    }
  }

  query () {
    return this.fetch({
      data: this.params(),
      reset: true
    })
  }
}
